export type Sentiment = 'positive' | 'neutral' | 'negative' | 'unavailable';

export interface NewsArticle {
  title: string;
  link: string;
  source: string;
  author?: string;
  publishedAt: string;
  sentiment: Sentiment;
}

export interface NewsResponse {
  articles: NewsArticle[];
  cachedAt: string;
  expiresAt: string;
  hasSentiment: boolean;
  sentimentUnavailable?: boolean;
}

export interface ArticleSummary {
  summary: string;
  cachedAt: string;
}

export const NEWS_CONFIG = {
  defaultArticleCount: 5,
  cacheTTLSeconds: 86400, // 24 hours
  summaryCacheTTLSeconds: 1209600, // 14 days
} as const;
